import React from 'react';
import classNames from 'classnames';
import Icon from '~/app/common/Icon';
import classes from './style.module.scss';
import useTranslation from "~/app/hooks/useTranslation";
import LinkWrapper from "~/app/common/LinkWrapper";
import { TRAINING_ROUTES } from '~/training/Router';
import {route} from "~/app/helpers/route";
import { Training } from '~/training/types';

export interface ListItemProps {
    item: Training
    listClassName?: string
}

export type ListItemComponent = React.FC<ListItemProps>

const ListItem: ListItemComponent = ({item, listClassName}) => {

    const { t } = useTranslation("training");

    return (
        <LinkWrapper
            className={`${classes['list-item']} ${listClassName && classes[listClassName]}`}
            to={route(TRAINING_ROUTES.details, {id: item.id})}
            >
            <div className={classes['info']}>
                <div className={classes['title']}>{item.title}</div>
                <div className={classes['details']}>
                    <span>{item.trainingDate}</span>
                    <span className={`${classes['status']} ${classes[item.status]}`}>{t(`status.${item.status}`)}</span>
                </div>
            </div>
            <div className={classNames(classes['right-icon-wrap'])}>
                <Icon name="keyboard_arrow_right"/>
            </div>
        </LinkWrapper>
    );
};

export default ListItem
